import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "./utils"; // assumes you use clsx or a similar utility

const buttonVariants = cva(
  "btn d-inline-flex align-items-center justify-content-center gap-2 fw-medium transition", // base bootstrap utility classes
  {
    variants: {
      variant: {
        default: "btn-primary",
        destructive: "btn-danger",
        outline: "btn-outline-secondary",
        secondary: "btn-secondary",
        ghost: "btn-outline-light text-dark", // approximate 'ghost' style
        link: "btn btn-link text-primary text-decoration-underline",
      },
      size: {
        default: "py-2 px-4", // default size
        sm: "btn-sm",          // Bootstrap small
        lg: "btn-lg",          // Bootstrap large
        icon: "p-2 d-flex align-items-center justify-content-center", // square icon-only
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size }), className)}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
